var cilHttps = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M400,200H388V144a128,128,0,0,0-256,0v56H120a24.028,24.028,0,0,0-24,24V472a24.028,24.028,0,0,0,24,24H400a24.028,24.028,0,0,0,24-24V224A24.028,24.028,0,0,0,400,200ZM164,144a96,96,0,0,1,192,0v56H164ZM392,464H128V232H392Z' class='ci-primary'/><rect width='40' height='40' x='240' y='328' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilHttps };

